import React from "react";

import classes from "./HeroShot.module.css";
import HeroShotPicture from "../Assets/Images/HeroShot.jpg";

export default function HeroShot() {
  return (
    <img
      width="300px"
      height="200px"
      className={`${classes.center} ${classes.heroShotDimensions} ${classes.heroShotStyle}`}
      src={HeroShotPicture}
      alt="Woman holds flower"
    />
  );
}
